import React from 'react';

import { Parallax } from 'rc-scroll-anim';

import { ReactComponent as Nature } from '@assets/images/icons/nature.svg';
import { ReactComponent as World } from '@assets/images/icons/world.svg';

import mainImgLeft1 from '@assets/images/videos/video-1/item-1.webp';
import mainImgRight1 from '@assets/images/videos/video-2/item-1.webp';

import mainImgLeft2 from '@assets/images/videos/video-3/item-1.webp';
import mainImgRight2 from '@assets/images/videos/video-4/item-1.webp';

import mainImgLeft3 from '@assets/images/videos/video-5/item-1.webp';
import mainImgRight3 from '@assets/images/videos/video-6/item-1.webp';

type ImageIconTypes = {
  active?: boolean;
  index?: number;
};

const ImageIcon: React.FC<ImageIconTypes> = ({ active, index }) => {

  if (index === 3) {
    return (
      <>
        {active ?
          <img className="relative -mb-10 -mt-6 -right-6" src={mainImgRight3} width="157" height="137" alt="" />
        :
          <img className="relative -mb-13 -mt-6 -right-2" src={mainImgLeft3} width="110" height="110" alt="" />
        }
      </>
    );
  } else if (index === 2) {
    return (
      <>
        {active ?
          <img className="relative -mb-12 -mt-4" src={mainImgRight2} width="122" height="122" alt="" />
        :
          <img className="relative -mb-16 -mt-8 -right-6 transform rotate-6" src={mainImgLeft2} width="123" height="107" alt="" />
        }
      </>
    );
  } else {
    return (
      <>
        {active ?
          <img className="-my-8" src={mainImgRight1} width="122" height="122" alt="" />
        :
          <img className="-mb-20" src={mainImgLeft1} width="100" height="139" alt="" />
        }
      </>
    );
  }
};

type BlockColoredTextTypes = {
  headerLeft?: string;
  textLeft?: string;
  headerRight?: string;
  textRight?: string;
  index?: number;
  isDesktopOrLaptop?: any;
  active?: boolean;
  onClick?: () => void;
};

export const BlockColoredText: React.FC<BlockColoredTextTypes> = ({ children, ...props }) => {
  const {
    headerLeft,
    textLeft,
    headerRight,
    textRight,
    index,
    active,
    onClick,
    isDesktopOrLaptop
  } = props;

  return (
    <>
        {!isDesktopOrLaptop &&
        <div
          className="
            flex
            justify-between
            max-w-full
            overflow-hidden
            mx-5
            pb-20
            -mb-12
          "
        >
          <Parallax
            animation={{ scale: 1, opacity: 1, playScale: [0.25, 0.50] }}
            style={{ transform: 'scale(0.5)', opacity: 0 }}
            className={`
              bg-white
              relative
              inline-flex
              justify-center
              items-center
              border
              border-white
              rounded-full
              w-15
              h-15
              flex-shrink-0
              z-10
            `}
          >
            {active ?
              <Nature
                className={`
                  fill-current
                  text-smGrayText
                `}
                width={23}
                height={36}
              />
            :
              <World
                className={`
                  fill-current
                  text-smGrayText
                `}
                width={37}
                height={37}
              />
            }
          </Parallax>
          <Parallax
            animation={{ scale: 1, opacity: 1, playScale: [0.25, 0.50] }}
            style={{ transform: 'scale(0.5)', opacity: 0 }}
            className={`
              relative
              inline-flex
              justify-end
              items-center
              flex-shrink-0
              z-10
            `}
          >
            <ImageIcon
              active={active}
              index={index}
            />
          </Parallax>
        </div>}
      <div
        className="
          max-w-1160
          mx-auto
          flex
          flex-col
          lg:flex-row
          justify-between
          w-full
          font-extrabold
          text-white
          mt-0
          lg:mt-10
          mb-5
          px-5
          lg:px-15
        "
      >
        {(!isDesktopOrLaptop && !active || isDesktopOrLaptop) && <Parallax
          animation={{ y: 0, opacity: 1, playScale: [0.20, 0.50] }}
          style={{ transform: isDesktopOrLaptop ? 'translateY(-100px)' : 'translateY(-50px)', opacity: 0 }}
          className="code-box-shape flex-1 pl-0 pr-5"
        >
          <div className="flex-1 text-2xl lg:text-3xl leading-8.5 lg:leading-11">
            <h3 className="mb-3 lg:mb-8 text-redText">
              {headerLeft}
            </h3>
            <div className="max-w-mdlg">
              {textLeft}
            </div>
          </div>
        </Parallax>}
        {(!isDesktopOrLaptop && active || isDesktopOrLaptop) && <Parallax
          animation={{ y: 0, opacity: 1, playScale: [0.20, 0.50] }}
          style={{ transform: isDesktopOrLaptop ? 'translateY(-100px)' : 'translateY(-50px)', opacity: 0 }}
          className="code-box-shape flex-1 lg:pl-5 pr-0"
        >
          <div className="flex-1 text-2xl lg:text-3xl leading-8.5 lg:leading-11">
            <h3 className="mb-3 lg:mb-8 text-greenText">
              {headerRight}
            </h3>
            <div className="max-w-mdlg">
              {textRight}
            </div>
          </div>
        </Parallax>}
      </div>
    </>
  );
}